import { useEffect, useState } from "react";

import { Button, Grid, Typography, Tabs, Tab, Box } from "@pankod/refine-mui";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";
import SimpleUploadZone from "../../components/SimpleUploadZone";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PackagingEditor from "components/PackagingEditor";

import { useSelect } from "@pankod/refine-core";
import axios from "utils/axios";
import { toast } from "react-toastify";
import { normalizeData } from "utils/utils";

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      sx={{ width: "100%" }}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
};

export default function CompFields({
  register,
  errors,
  control,
  getValues,
  setValue,
  record,
}) {
  const [productPhoto, setProductPhoto] = useState();
  const [packagings, setPackagings] = useState(record?.packagings || []);
  const [openTab, setOpenTab] = useState(0);

  useEffect(() => {
    if (record && record.packagings) setPackagings(record.packagings);
  }, [record]);

  const refreshPackagings = async () => {
    try {
      const { data: productDeets } = await axios.get(
        `/api/products/${record.id}?populate=*`
      );
      const norm = normalizeData(productDeets);
      const newPackagings = [...norm.packagings];
      setPackagings(newPackagings);
    } catch (error) {
      console.log(error);
    }
  };

  const { options: product_categories } = useSelect({
    resource: "product-categories",
    optionLabel: "name",
    optionValue: "id",
    pagination: {
      pageSize: 100,
    },
  });

  useEffect(() => {
    if (record && product_categories.length > 0 && record.product_category) {
      setValue("product_category", record.product_category.id);
    }
  }, [product_categories, record, setValue]);

  useEffect(() => {
    if (record && record.image) setProductPhoto(record.image);
  }, [record]);

  const removePhoto = async (photoId) => {
    try {
      await axios.delete(`/api/upload/files/${photoId}`);

      toast.success("foto eliminata");
      setProductPhoto(null);
      setValue("image", null);
    } catch (error) {
      toast.error("Si è verificato un errore");
    }
  };

  // base fields
  const fields = [
    {
      label: "Nome",
      name: "name",
      required: true,
      type: "text",
      md: 6,
      style: { marginBottom: "20px" },
    },
    {
      label: "Categoria",
      name: "product_category",
      required: true,
      type: "select",
      options: product_categories,
      md: 6,
    },
    {
      label: "Descrizione",
      name: "description",
      required: true,
      type: "text",
      lines: 12,
      md: 12,
      style: { marginBottom: "20px" },
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Tabs
          value={openTab}
          onChange={(e, value) => setOpenTab(value)}
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab label="Dettagli Prodotto" />
          <Tab label="Confezionamenti" />
        </Tabs>
        <TabPanel value={openTab} index={0}>
          <Grid container spacing={2} style={{ padding: "30px" }}>
            {fields.map((field, index) => {
              return (
                <AutoGeneratedInputCmp
                  key={index}
                  {...field}
                  register={register}
                  control={control}
                  errors={errors}
                  getValues={getValues}
                  setValue={setValue}
                />
              );
            })}
          </Grid>
          <Grid
            container
            spacing={2}
            direction="column"
            style={{ padding: "30px" }}
            justifyContent="center"
            gap={2}
            alignItems="start"
          >
            <Typography variant="h6" ml={2}>
              Foto prodotto
            </Typography>

            {productPhoto ? (
              <div>
                <img
                  src={`${process.env.REACT_APP_API_URL}${productPhoto.url}`}
                  width={300}
                  height={"auto"}
                  alt="product"
                />
                <DeleteForeverIcon
                  onClick={() => removePhoto(productPhoto.id)}
                  sx={{ color: "red", cursor: "pointer" }}
                />
              </div>
            ) : (
              <SimpleUploadZone
                label="CARICA FOTO"
                onChange={async (file) => {
                  toast.success("Foto caricata con successo");
                  try {
                    setValue("image", file.id);
                    setProductPhoto(file);
                  } catch (error) {
                    toast.error("Foto non caricata");
                  }
                }}
              />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={openTab} index={1}>
          <Grid
            container
            spacing={2}
            direction="column"
            style={{ padding: "30px" }}
            justifyContent="center"
            gap={2}
            alignItems="start"
          >
            <Grid container rowSpacing={3} sx={{ mt: 4 }}>
              {packagings.map((packaging, index) => {
                return (
                  <Grid item xs={12} key={index}>
                    <PackagingEditor
                      key={index}
                      packaging={packaging}
                      refreshPackagings={refreshPackagings}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={async () => {
                  try {
                    const { data } = await axios.post("/api/packagings", {
                      data: { product: record.id },
                    });
                    await refreshPackagings();
                    toast.success("Confezionamento creato");
                  } catch (error) {
                    toast.error("Si è verificato un errore");
                    console.log(error);
                  }
                }}
              >
                Aggiungi confezionamento
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      </Grid>
    </Grid>
  );
}
